const activateTooltip = () => {
  const { $ } = window;
  setTimeout(() => $('[data-toggle="tooltip"]').tooltip(), 2000);
};

export default activateTooltip;
